import React from 'react'
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

function ContactUs() {
  return (
    <>
      <Navbar page={'contact'} />
      <Footer />
    </>
  )
}

export default ContactUs